import React, { useMemo } from 'react';
import { MODEL_TYPE } from 'config/constants';
import { t } from 'i18next';
import { getCssVar, uniqueId } from 'utils';

interface PlotScalingLegendProps {
  modelType: string;
  filters: string[];
  clickFilter?: (status: string) => void;
}
const defaultLegends = [
  {
    title: t('components:plot_scaling.legend.no_alarming'),
    label: 'normal',
    color: '#63DC76',
    icon: 'circle',
  },
  {
    title: t('components:plot_scaling.legend.warning'),
    label: 'warning',
    color: '#FFB054',
    icon: 'circle',
  },
  {
    title: t('components:plot_scaling.legend.alarming'),
    label: 'alarming',
    color: getCssVar('--red-1'),
    icon: 'circle',
  },
];
const legendsLimits = [
  {
    title: t('components:plot_scaling.legend.upper_limit'),
    label: 'normal',
    color: getCssVar('--red-2'),
    icon: 'rect',
  },
  {
    title: t('components:plot_scaling.legend.target_region'),
    label: 'warning',
    color: getCssVar('--green-1'),
    icon: 'rect',
  },
  {
    title: t('components:plot_scaling.legend.lower_limit'),
    label: 'alarming',
    color: getCssVar('--gray-5'),
    icon: 'rect',
  },
];
const learnedRegion = {
  title: t('components:plot_scaling.legend.learned_region'),
  label: 'learned',
  color: '#666666',
  icon: 'rect',
};
const PlotScalingLegend: React.FC<PlotScalingLegendProps> = ({
  modelType,
  filters,
  clickFilter,
}) => {
  const legends = useMemo(
    () =>
      MODEL_TYPE.SCALING_OPERATION_POINT !== modelType
        ? [...defaultLegends, learnedRegion]
        : [...defaultLegends, ...legendsLimits],
    [modelType],
  );

  return (
    <ul className="plotScaling-legend">
      {legends.map((item) => (
        <li
          className={`${filters.indexOf(item.label) === -1 ? 'is-disabled' : ''}`}
          key={uniqueId()}
        >
          <button type="button" onClick={() => clickFilter && clickFilter(item.label)}>
            <span
              className={`plotScaling-badge plotScaling-${item.icon}`}
              style={{ background: item.color }}
            />
            {item.title}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default PlotScalingLegend;
